export default "__VITE_ASSET__C39rY1Ss__"